import React from 'react'

import { ChatMessagePointer, IconInteracty } from '../svg/index'

import './QAChat.scss'

const QAChat = ({ data, className = '' }) => {
    return (
        <div className={`QA-chat ${className}`}>
            {data.map(([type, text], i) => (
                <div className={`QA-chat__${type}`} key={i}>
                    {type === 'question' ? <div className="QA-chat__empty-box"></div> : null}
                    {type === 'answer' ? (
                        <div className="QA-chat__icon-box">
                            <IconInteracty />
                        </div>
                    ) : null}
                    <div className="QA-chat__message-box">
                        <div className="QA-chat__message">{text}</div>
                        <div className="QA-chat__pointer-box">
                            <ChatMessagePointer />
                        </div>
                    </div>
                    {type === 'answer' ? <div className="QA-chat__empty-box"></div> : null}
                </div>
            ))}
        </div>
    )
}

export default QAChat
